import { createReducer } from 'redux-act';
import actions from '../actions/feedbackActions';

const initialState = {
    createFeedbackTeamPending: false,
    createFeedbackTeamRes: null,
    createFeedbackTeamError: null,

    getAllFeedbackTeamsPending: false,
    getAllFeedbackTeamsRes: null,
    getAllFeedbackTeamsError: null,

    createFeedbackPending: false,
    createFeedbackRes: null,
    createFeedbackError: null,

    givenFeedbackPending: false,
    givenFeedbackRes: null,
    givenFeedbackError: null,

    getReceivedFeedbackOnFilterPending: false,
    getReceivedFeedbackOnFilterRes: null,
    getReceivedFeedbackOnFilterError: null,

    getFeedbackDashboardDataPending: false,
    getFeedbackDashboardDataRes: null,
    getFeedbackDashboardDataError: null,
};
/* Create Feedback Team Reducers */
const handleCreateFeedbackTeamRequest = state => {
    return {
        ...state,
        ...{
            createFeedbackTeamPending: true,
            createFeedbackTeamRes: null,
            createFeedbackTeamError: null,
        },
    };
};
const handleCreateFeedbackTeamSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createFeedbackTeamPending: false,
            createFeedbackTeamRes: payload,
            createFeedbackTeamError: null,
        },
    };
};
const handleCreateFeedbackTeamError = (state, payload) => ({
    ...state,
    ...{
        createFeedbackTeamPending: false,
        createFeedbackTeamRes: null,
        createFeedbackTeamError: payload,
    },
});


/* Get All Feedback Teams Reducers */
const handleGetAllFeedbackTeamsRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllFeedbackTeamsPending: true,
            getAllFeedbackTeamsRes: null,
            getAllFeedbackTeamsError: null,
        },
    };
};
const handleGetAllFeedbackTeamsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllFeedbackTeamsPending: false,
            getAllFeedbackTeamsRes: payload,
            getAllFeedbackTeamsError: null,
        },
    };
};
const handleGetAllFeedbackTeamsError = (state1, payload) => ({
    ...state1,
    ...{
        getAllFeedbackTeamsPending: false,
        getAllFeedbackTeamsRes: null,
        getAllFeedbackTeamsError: payload,
    },
});

/* Create Feedback Reducers */
const handleCreateFeedbackRequest = state1 => {
    return {
        ...state1,
        ...{
            createFeedbackPending: true,
            createFeedbackRes: null,
            createFeedbackError: null,
        },
    };
};
const handleCreateFeedbackSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createFeedbackPending: false,
            createFeedbackRes: payload,
            createFeedbackError: null,
        },
    };
};
const handleCreateFeedbackError = (state1, payload) => ({
    ...state1,
    ...{
        createFeedbackPending: false,
        createFeedbackRes: null,
        createFeedbackError: payload,
    },
});

/* Given Feedback Reducers */
const handleGivenFeedbackRequest = state1 => {
    return {
        ...state1,
        ...{
            givenFeedbackPending: true,
            givenFeedbackRes: null,
            givenFeedbackError: null,
        },
    };
};
const handleGivenFeedbackSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            givenFeedbackPending: false,
            givenFeedbackRes: payload,
            givenFeedbackError: null,
        },
    };
};
const handleGivenFeedbackError = (state1, payload) => ({
    ...state1,
    ...{
        givenFeedbackPending: false,
        givenFeedbackRes: null,
        givenFeedbackError: payload,
    },
});

/* Get Received Feedback On Filter Reducers*/
const handleGetReceivedFeedbackOnFilterRequest = state1 => {
    return {
        ...state1,
        ...{
            getReceivedFeedbackOnFilterPending: true,
            getReceivedFeedbackOnFilterRes: null,
            getReceivedFeedbackOnFilterError: null,
        },
    };
};
const handleGetReceivedFeedbackOnFilterSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getReceivedFeedbackOnFilterPending: false,
            getReceivedFeedbackOnFilterRes: payload,
            getReceivedFeedbackOnFilterError: null,
        },
    };
};
const handleGetReceivedFeedbackOnFilterError = (state1, payload) => ({
    ...state1,
    ...{
        getReceivedFeedbackOnFilterPending: false,
        getReceivedFeedbackOnFilterRes: null,
        getReceivedFeedbackOnFilterError: payload,
    },
});


/* Get Feedback Dashboard Data Reducers*/
const handleGetFeedbackDashboardDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getFeedbackDashboardDataPending: true,
            getFeedbackDashboardDataRes: null,
            getFeedbackDashboardDataError: null,
        },
    };
};
const handleGetFeedbackDashboardDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getFeedbackDashboardDataPending: false,
            getFeedbackDashboardDataRes: payload,
            getFeedbackDashboardDataError: null,
        },
    };
};
const handleGetFeedbackDashboardDataError = (state1, payload) => ({
    ...state1,
    ...{
        getFeedbackDashboardDataPending: false,
        getFeedbackDashboardDataRes: null,
        getFeedbackDashboardDataError: payload,
    },
});

// Clear Existing Data Store Reducers*/
const clearFeedbackStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_CREATE_FEEDBACK_TEAM_STORE':
            return {
                ...state,
                ...{
                    createFeedbackTeamPending: false,
                    createFeedbackTeamRes: null,
                    createFeedbackTeamError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_FEEDBACK_STORE':
            return {
                ...state,
                ...{
                    createFeedbackPending: false,
                    createFeedbackRes: null,
                    createFeedbackError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.createFeedbackTeamRequest]: handleCreateFeedbackTeamRequest,
        [actions.createFeedbackTeamSuccess]: handleCreateFeedbackTeamSuccess,
        [actions.createFeedbackTeamError]: handleCreateFeedbackTeamError,

        [actions.getAllFeedbackTeamsRequest]: handleGetAllFeedbackTeamsRequest,
        [actions.getAllFeedbackTeamsSuccess]: handleGetAllFeedbackTeamsSuccess,
        [actions.getAllFeedbackTeamsError]: handleGetAllFeedbackTeamsError,

        [actions.createFeedbackRequest]: handleCreateFeedbackRequest,
        [actions.createFeedbackSuccess]: handleCreateFeedbackSuccess,
        [actions.createFeedbackError]: handleCreateFeedbackError,

        [actions.givenFeedbackRequest]: handleGivenFeedbackRequest,
        [actions.givenFeedbackSuccess]: handleGivenFeedbackSuccess,
        [actions.givenFeedbackError]: handleGivenFeedbackError,

        [actions.getReceivedFeedbackOnFilterRequest]: handleGetReceivedFeedbackOnFilterRequest,
        [actions.getReceivedFeedbackOnFilterSuccess]: handleGetReceivedFeedbackOnFilterSuccess,
        [actions.getReceivedFeedbackOnFilterError]: handleGetReceivedFeedbackOnFilterError,

        [actions.getFeedbackDashboardDataRequest]: handleGetFeedbackDashboardDataRequest,
        [actions.getFeedbackDashboardDataSuccess]: handleGetFeedbackDashboardDataSuccess,
        [actions.getFeedbackDashboardDataError]: handleGetFeedbackDashboardDataError,

        [actions.handleClearFeedbackStore]: clearFeedbackStore,
    },
    initialState,
);